import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'MobileSearchBox',
      type: 'SearchBox',
      location: '#cm-search-box-mobile',
      template: 'SearchBox',
    },
  ],
};
